// extracted by mini-css-extract-plugin
export default {"logo":"header_logo__UESgy"};